import { Group, Stack, Title, Text, Button } from '@mantine/core';
import { AppIcon } from '../common/AppIcon';
import { currentUser, trial } from '../../data/mockData';

export function WelcomeHeader() {
  return (
    <Group justify="space-between" align="flex-start" wrap="wrap" gap="md" mb="xl">
      <Stack gap={0}>
        <Group gap={6}>
          <AppIcon name="calendar" size={16} />
          <Text fz="sm" c={"primary.9"}>{trial.dateLabel}</Text>
        </Group>
        <Title order={2} fz={{ base: 26, sm: 30 }}>
          Bonjour {currentUser.firstName}
        </Title>
        <Text fz="sm" fw={500} c="#ff7b9c">
          Il vous reste {trial.daysLeft} jours d'essai gratuit
        </Text>
      </Stack>

      <Button
        size="md"
        radius="lg"
        color="primary"
        leftSection={<AppIcon name="rocket" size={18} />}
        fw={600}
      >
        Choisir un plan Magileads
      </Button>
    </Group>
  );
}

export default WelcomeHeader;
